/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Comms/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Comms({
  children,
  viewPath = "/App/Account/Content/Tasks/New/TaskOverlay/Content/Content/Comms"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedCommsThreadIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'comms.thread_id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(selectedCommsThreadIdValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}